<template>
  <div class="cell">
    <div class="flex-line">
      <div>
        <span class="bold-caps">{{ label }}</span>
      </div>
      <div
        v-if="newLabel"
        :class="{ 'add-purple': isPurple }"
        class="add"
        @click="$emit('add', $event)"
      >
        <div class="icon-svg icon-svg-mr4 w-embed">
          <PlusIcon />
        </div>
        <div>{{ newLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import PlusIcon from '@/assets/icons/plus.svg';

  export default {
    name: 'TotalName',
    components: { PlusIcon },
    props: {
      label: {
        type: String,
        required: true,
      },

      newLabel: {
        type: String,
        default: '',
      },

      isPurple: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style lang="scss" scoped>
  .bold-caps {
    margin: -12px -12px 8px;
    padding: 8px 12px;
    border-bottom: 1px solid #f3f3f9;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }
</style>
